// The 8-slot/day shift model (prototype data.js): 4 AM slots (08:00–11:00) +
// 4 PM slots (15:30–18:30). Any staff can fill any slot.
export const AM_TIME = { start: '08:00', end: '11:00' };
export const PM_TIME = { start: '15:30', end: '18:30' };
export const SLOTS_PER_GROUP = 4;

export interface SlotTemplate {
  slot: number;
  kind: 'am' | 'pm';
  start: string;
  end: string;
}

export const SHIFT_TEMPLATES: SlotTemplate[] = [
  ...Array.from({ length: SLOTS_PER_GROUP }, (_, i) => ({ slot: i, kind: 'am' as const, ...AM_TIME })),
  ...Array.from({ length: SLOTS_PER_GROUP }, (_, i) => ({ slot: i + SLOTS_PER_GROUP, kind: 'pm' as const, ...PM_TIME })),
];

// The first free slot in a period for a day, or null if the period is full.
// `filled` is the set of occupied slot indices for that date.
export function getNextSlot(period: 'am' | 'pm', filled: Set<number>): number | null {
  const base = period === 'am' ? 0 : SLOTS_PER_GROUP;
  for (let i = base; i < base + SLOTS_PER_GROUP; i++) {
    if (!filled.has(i)) return i;
  }
  return null;
}

// Which period a slot belongs to.
export function periodOf(slot: number): 'am' | 'pm' {
  return slot < SLOTS_PER_GROUP ? 'am' : 'pm';
}

// The staff already assigned to a period on a date, excluding one slot (the one
// being edited). A helper can work both AM and PM the same day, but not two
// slots of the same period — so the editor disables anyone in this set.
export function staffAssignedInPeriod(
  shifts: { date: string; slot: number; staffId: string | null }[],
  date: string,
  period: 'am' | 'pm',
  excludeSlot: number,
): Set<string> {
  const out = new Set<string>();
  for (const s of shifts) {
    if (s.date !== date || s.slot === excludeSlot) continue;
    if (periodOf(s.slot) !== period) continue;
    if (s.staffId) out.add(s.staffId);
  }
  return out;
}
